import clsx from "clsx";
import {
  Clock3,
  FileCheck2,
  ShieldCheck,
  ShieldX,
  type LucideIcon,
} from "lucide-react";

import { Card } from "../../../shared/card/card.tsx";
import type { InsuranceStats } from "../types.ts";

import styles from "./insurance-stats.module.css";

type StatKey = keyof InsuranceStats;

const TILES: Array<{
  key: StatKey;
  label: string;
  icon: LucideIcon;
  tone: string;
}> = [
  {
    key: "totalInsuranceHolders",
    label: "Total Insurance Holders",
    icon: ShieldCheck,
    tone: "blue",
  },
  { key: "pending", label: "Pending", icon: Clock3, tone: "amber" },
  { key: "approved", label: "Approved", icon: FileCheck2, tone: "green" },
  { key: "revoked", label: "Revoked", icon: ShieldX, tone: "red" },
];

export function InsuranceStatsCards({
  stats,
  loading,
}: {
  stats: InsuranceStats;
  loading?: boolean;
}) {
  return (
    <div className={styles.grid} aria-busy={loading || undefined}>
      {TILES.map(({ key, label, icon: Icon, tone }) => (
        <Card key={key} className={styles.card} padding="3xl">
          <div className={styles.inner}>
            <span className={clsx(styles.icon, styles[tone])} aria-hidden>
              <Icon size={21} strokeWidth={2} />
            </span>
            <div>
              <p className={clsx("sub-heading-xs", styles.label)}>{label}</p>
              <p className={clsx("heading-lg", styles.value)}>
                {loading ? "—" : stats[key].toLocaleString()}
              </p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
